// frontend/src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";

const rawMeasurementId = import.meta.env.VITE_FIREBASE_MEASUREMENT_ID;
const measurementId =
  rawMeasurementId && rawMeasurementId.trim() !== ""
    ? rawMeasurementId.startsWith("G-")
      ? rawMeasurementId
      : `G-${rawMeasurementId}`
    : undefined;

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  ...(measurementId ? { measurementId } : {}),
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Analytics seulement si côté navigateur ET supporté
if (typeof window !== "undefined") {
  isSupported()
    .then((ok) => {
      if (ok) getAnalytics(app);
    })
    .catch(() => {});
}

export default app;
